import { Component } from '@angular/core';

import { ModalService } from 'src/app/core/modal.service';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.css']
})
export class ConfirmationModalComponent {
  title = "";
  text = "";

  constructor(private modalService: ModalService){ }

  confirmClicked(){
    this.modalService.submitClicked.next(true)
    this.modalService.closeModal()
  }
  cancelClicked(){
    this.modalService.closeModal()
  }

}
